module.exports = __webpack_public_path__ + "static/media/generate-investor-report.892e3284.svg";